<template>
    <ul class="lender-stats">
        <li
            v-for="(stat, index) in stats"
            :key="index"
        >
            <span>{{ stat.label }}:</span>
            <div>
                <span v-html="stat.value" />
                <Tooltip 
                    :data="stat.tooltipText"
                />
            </div>
        </li>
    </ul>
</template>

<script>

import { capitalize } from 'lodash';
import Tooltip from '@/components/features/Tooltip.vue';
export default {
    components: {
        Tooltip
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        statsType: {
            type: String,
            required: false,
            default: 'private'
        }
    },
    data() {

        let stats = [
            {
                label: this.$translate('amount', 'Belopp'),
                value: this.model.amountString
            },
            {
                label: this.$translate('duration', 'Löptid'),
                value: this.model.getDurationString(this.$translate('month_short', 'mån'), this.$translate('year', 'år'))
            }
        ];

        if (this.model.isBroker) {
            stats.push({
                label: this.$translate('connected_banks', 'Anslutna långivare'),
                value: this.model.connectedBanks
            });
        }

        stats = stats.concat([
            {
                label: this.$translate('ld_payment_remarks_label', 'Betalningsanmärkningar'),
                value: this.model.acceptsPaymentRemarks.company ? this.$translate('accepted', 'Accepteras') : this.$translate('not_accepted', 'Accepteras inte')
            },
            {
                label: this.$translate('requires_collateral_in_company', 'Säkerhet i företaget'),
                value: this.model.requiresCollateral ? this.$translate('required', 'Krävs') : this.$translate('not_required', 'Krävs ej')
            },
            {
                label: this.$translate('without_personal_bail', 'Utan personlig borgen'),
                value: this.$formatBoolean(!this.model.requiresPersonalBail)
            },
        ]);

        if (this.model.companyRequirements.minRevenue) {
            stats.push({
                label: this.$translate('min_revenue', 'Minsta omsättning'),
                value: this.model.companyRequirementsString.minRevenue
            });
        }

        if (this.model.companyRequirements.minAge) {
            stats.push({
                label: this.$translate('company_history_label', 'Företagets historik'),
                value: this.$translate('company_history_explanation', 'Aktivt i minst {minAge}')
                    .replace('{minAge}', this.model.companyRequirementsString.minAge)
            });
        }

        stats = stats.concat([
            {
                label: this.$translate('company_credit_check_label', 'Kreditupplysning på företaget'),
                value: capitalize(this.model.creditCheck.company)
            },
            {
                label: this.$translate('credit_check_on_the_representative_label', 'Kreditupplysning på företrädaren'),
                value: capitalize(this.model.creditCheck.repersentative)
            },
            {
                label: this.$translate('accepts_enskild_firma_label', 'Lån till enskild firma'),
                value: this.$formatBoolean(this.model.acceptsEnskildFirma)
            },
            {
                label: this.$translate('accepts_aktiebolag_label', 'Lån till Aktiebolag'),
                value: this.$formatBoolean(this.model.acceptsAktiebolag)
            },
            {
                label: this.$translate('accepts_handelsbolag_label', 'Lån till Handelsbolag'),
                value: this.$formatBoolean(this.model.acceptsHandelsbolag)
            },
            {
                label: this.$translate('accepts_kommanditbolag_label', 'Lån till Kommanditbolag'),
                value: this.$formatBoolean(this.model.acceptsKommanditbolag)
            },
            {
                label: this.$translate('factoring', 'Factoring'),
                value: this.$formatBoolean(this.model.hasFactoring),
                tooltipText: this.$translate('factoring_tooltip', 'Factoring är när ett företag säljer eller belånar sina kundfakturor via ett finansbolag för att få pengar direkt i stället för att vänta på kundernas betalning.')
            }
        ]);

        return {
            stats: stats
        };
    }
};
</script>
